import React from 'react';

const ArrowNarrowNextIcon = ({isDisable}: {isDisable: boolean}) => {
    return (
        <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M22 44C9.84974 44 0 34.1503 0 22C0 9.84974 9.84974 0 22 0C34.1503 0 44 9.84974 44 22C44 34.1503 34.1503 44 22 44ZM30.6187 22.6187L22.6187 30.6187C22.277 30.9604 21.723 30.9604 21.3813 30.6187C21.0396 30.277 21.0396 29.723 21.3813 29.3813L27.8876 22.875H14C13.5168 22.875 13.125 22.4832 13.125 22C13.125 21.5168 13.5168 21.125 14 21.125H27.8876L21.3813 14.6187C21.0396 14.277 21.0396 13.723 21.3813 13.3813C21.723 13.0396 22.277 13.0396 22.6187 13.3813L30.6187 21.3813C30.9604 21.723 30.9604 22.277 30.6187 22.6187Z"
                fill={`${isDisable ? '#D7D7D7' : 'url(#paint0_linear_2002_747)'}`}
            />
            <defs>
                <linearGradient
                    id="paint0_linear_2002_747"
                    x1="-33.5"
                    y1="47.5"
                    x2="48.2321"
                    y2="62.7025"
                    gradientUnits="userSpaceOnUse">
                    <stop stopColor="#0041EA" />
                    <stop offset="0.333333" stopColor="#3BACF7" />
                    <stop offset="0.445" stopColor="#7C86D4" />
                    <stop offset="0.76" stopColor="#FF31D2" />
                    <stop offset="1" stopColor="#FF398C" />
                </linearGradient>
            </defs>
        </svg>
    );
};

export default ArrowNarrowNextIcon;
